import SpotLight from "./SpotLight"

export default SpotLight
